import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { tenantApi } from '@/modules/tenant/services/tenantApi';

export interface DealershipProfile {
  id: string;
  business_name: string;
  legal_name?: string | null;
  tax_id?: string | null;
  license_number?: string | null;
  email: string;
  phone?: string | null;
  website?: string | null;
  address?: string | null;
  city?: string | null;
  state?: string | null;
  postal_code?: string | null;
  country?: string | null;
  timezone?: string | null;
  logo_url?: string | null;
  primary_color?: string | null;
  secondary_color?: string | null;
  business_hours?: Record<string, unknown> | null;
  created_at: string;
  updated_at: string;
}

export type DealershipProfileUpdateInput = Partial<
  Omit<DealershipProfile, 'id' | 'created_at' | 'updated_at' | 'logo_url'>
>;

export function useDealershipProfile() {
  return useQuery({
    queryKey: ['dealership-profile'],
    queryFn: () => tenantApi.getOne<DealershipProfile>('/dealership/profile'),
    staleTime: 5 * 60 * 1000,
  });
}

export function useUpdateDealershipProfile() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: DealershipProfileUpdateInput) =>
      tenantApi.putOne<DealershipProfile>('/dealership/profile', data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['dealership-profile'] });
    },
  });
}
